import { render } from "./chMedAnalyseView.vue?vue&type=template&id=f0b17678&scoped=true"
import script from "./chMedAnalyseView.vue?vue&type=script&lang=js"
export * from "./chMedAnalyseView.vue?vue&type=script&lang=js"

import "./chMedAnalyseView.vue?vue&type=style&index=0&id=f0b17678&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b17678"]])

export default __exports__